import { Injectable } from '@angular/core';
import { de } from 'date-fns/locale';

@Injectable({
  providedIn: 'root'
})
export class ParamsExtractorService {

  constructor() { }

  // getParamsData(data: Record<string, any>, params: string[]): { paramsData: Record<string, any>, objectKeys: string[] } {
  //   const paramsData: Record<string, any> = {};
  //   const objectKeys: string[] = [];

  //   //#region ignore case sensitive in obj keys
  //   const keysMap = Object.keys(data).reduce((acc, key) => {
  //     acc[key.toLowerCase()] = key;
  //     return acc;
  //   }, {} as Record<string, string>);

  //   params.forEach(param => {
  //     const matchedKey = keysMap[param.toLowerCase()];

  //     // ✅ الحالة الجديدة: param = اسم الـ object
  //     if (matchedKey && typeof data[matchedKey] === 'object') {
  //       const obj = data[matchedKey];
  //       objectKeys.push(matchedKey);

  //       if ('id' in obj) {
  //         paramsData[param] = obj.id;
  //       } else if ('code' in obj) {
  //         paramsData[param] = obj.code;
  //       }
  //       return; // نخرج من الـ forEach للـ param الحالي
  //     }

  //     let splitIndex = -1;

  //     // البحث عن آخر transition من lowercase لـ uppercase
  //     for (let i = 1; i < param.length; i++) {
  //       if (param[i].match(/[A-Z]/) && param[i - 1].match(/[a-z]/)) {
  //         splitIndex = i;
  //       }
  //     }
  //     //#endregion

  //     if (splitIndex > 0) {
  //       const rawObjectKey = param.slice(0, splitIndex);
  //       const propertyKey = param.slice(splitIndex);
  //       console.log(rawObjectKey, propertyKey);
  //       const propertyKeyFinal = propertyKey.charAt(0).toLowerCase() + propertyKey.slice(1);

  //       const matchedObjectKey = keysMap[rawObjectKey.toLowerCase()];
  //       const objectData = data[matchedObjectKey];

  //       console.log(matchedObjectKey)
  //       objectKeys.push(matchedObjectKey);
  //       // debugger
  //       if (objectData && objectData[propertyKeyFinal] !== undefined) {
  //         paramsData[param] = objectData[propertyKeyFinal];
  //         // console.log(this.paramsData)
  //       }
  //     }
  //   });
  //   return { paramsData, objectKeys };
  // }

  getParamsData(
    data: Record<string, any>,
    params: string[]
  ): { paramsData: Record<string, any>, objectKeys: string[] } {

    const paramsData: Record<string, any> = {};
    const objectKeys: string[] = [];

    //#region ignore case sensitive in obj keys
    const keysMap = Object.keys(data).reduce((acc, key) => {
      acc[key.toLowerCase()] = key;
      return acc;
    }, {} as Record<string, string>);
    //#endregion

    params.forEach(param => {
      console.log(`param: ${param}`);

      const lowerParam = param.toLowerCase();

      // ✅ الحالة 1: param = اسم الـ object نفسه
      const matchedKey = keysMap[lowerParam];
      console.log('matchedKey', matchedKey, data);
      // debugger
      if (matchedKey && data[matchedKey] !== null && data[matchedKey] !== undefined) {
        const value = data[matchedKey];

        // ✅ حالة الـ multi-select: القيمة Array
        if (Array.isArray(value)) {
          objectKeys.push(matchedKey);

          // لو array فاضية
          if (value.length === 0) {
            paramsData[param] = [];
            return;
          }

          // array of primitives (ids / codes جاهزة)
          if (typeof value[0] !== 'object') {
            paramsData[param] = value;
            return;
          }

          // array of objects → نحاول نطلع id / code / type من كل object
          const preferredKeys = ['id', 'code', 'type'];
          paramsData[param] = value.map(item => {
            if (!item || typeof item !== 'object') return item;
            for (const keyName of preferredKeys) {
              if (keyName in item) {
                return item[keyName];
              }
            }
            return item;
          });
          return;
        }

        // ✅ حالة object واحد
        if (typeof value === 'object') {
          const obj = value;
          objectKeys.push(matchedKey);
          console.log('objaaaa', obj);

          const preferredKeys = ['id', 'code', 'type'];

          for (const keyName of preferredKeys) {
            if (keyName in obj) {
              paramsData[param] = obj[keyName];
              // debugger
              break;
            }
          }
          return;
        }
        paramsData[param] = value;
        return;
      }

      console.log('matchedKey', matchedKey);
      console.log('data[matchedKey]', data[matchedKey]);


      // if (matchedKey) {
      //   const value = data[matchedKey];
      //   if (value && typeof value === 'object') {
      //     objectKeys.push(matchedKey);
      //     if ('id' in value) {
      //       paramsData[param] = value.id;
      //     } else if ('code' in value) {
      //       paramsData[param] = value.code;
      //     }
      //   } else {
      //     paramsData[param] = value; // 👈 ID string
      //     objectKeys.push(matchedKey);
      //   }
      //   return;
      // }

      // ✅ الحالة 2: param مركّب زي wfpositionid / wfpositioncode
      // ندور على أي suffix موجود في الـ object
      const matchedObjectKey = Object.keys(keysMap).find(k => lowerParam.startsWith(k));
      if (matchedObjectKey) {
        const objectData = data[keysMap[matchedObjectKey]];
        const suffix = lowerParam.slice(matchedObjectKey.length); // الباقي بعد اسم الـ object
        const propertyKeyFinal = suffix; // ممكن يبقى id, code, name...

        if (objectData && propertyKeyFinal in objectData) {
          paramsData[param] = objectData[propertyKeyFinal];
          objectKeys.push(keysMap[matchedObjectKey]);
          debugger
        }
      }
    });

    return { paramsData, objectKeys };
  }
}

